/**
 * Loading Skeleton Component
 * Displays while fonts are loading
 */
const LoadingSkeleton = () => {
  return (
    <div
      id="font-skeleton"
      className="fixed inset-0 z-[50000] flex animate-pulse items-center justify-center bg-zinc-900 text-zinc-600 transition-opacity duration-1000"
    >
      <div className="space-y-3">
        <div className="h-6 w-48 rounded bg-zinc-700/50" />
        <div className="h-4 w-64 rounded bg-zinc-700/40" />
        <div className="h-4 w-40 rounded bg-zinc-700/40" />
      </div>
    </div>
  );
};

export default LoadingSkeleton;
